import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTag]'
})
export class TagDirective {
  @Input() public appTag = false;
  public readonly REGEX_NUMBERS = /^[0-9]*$/;
  constructor(private el: ElementRef,
              private control: NgControl) { }

  /**
   * On keyup event put a dot every three characters.
   */
  @HostListener('keyup', ['$event'])
  public onEvent($event: KeyboardEvent): void {
    if (!$event.key.match(this.REGEX_NUMBERS)) {
      $event.preventDefault();
    }

    if (this.appTag) {
      let val = this.el.nativeElement.value.replace(/[^0-9]/g, '');
      if (val && val.length > 3) {
        val = [val.slice(0, 3), '.', val.slice(3, 6)].join('');
      }

      if (val.length < 7) {
        this.control.control.setValue(val);
      }
    }

  }
}
